import { CorrespondenceDocuments } from 'api';

export const getCorrespondenceDocumentFileUrl = (document: CorrespondenceDocuments) => {
  return document.document?.document_storage_item_url || document.report?.document_storage_item_url;
};
